import type { FaireBrandEntity } from "../../entity_types/brand";

// Dairy Brand — real Faire brand (b_2dvofcgxz7), shown under an anonymized name.
// Identity metadata from ANALYTICS.CANONICAL.BRANDS; backs the ads-manager-2
// "Dairy Brand" real-brand variant (advertiser 8749774711315878893).
//
// The display name, description, and location are deliberately generic: the real
// brand sits in a town small enough that naming it would identify it on its own,
// regardless of the rename. The token and advertiser id are kept so the Snowflake
// refresh path in snowflakeQueries.ts still resolves.
export const b_2dvofcgxz7: FaireBrandEntity = {
  token: "b_2dvofcgxz7",
  type: "brand",
  name: "Dairy Brand",
  description:
    "Small-batch cheese and cheese spreads, cut and packed to order.",
  location: "Midwest, USA",
  isTopShop: true,
  tags: ["food-drink", "dairy-meats"],
  meta: {
    source: "snowflake",
    importedAt: "2026-08-31T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
